import { staticConfig } from '../config/static';
export const defaultConfig = {
    links: {
        header: {
            help: {
                link: 'https://brugersupport.e-boks.dk/hc/da/',
                label: 'HELP',
            },
        },
        footer: {
            termsOfUse: {
                link: 'https://www.e-boks.com/danmark/da/vilkaar/',
                label: 'FOOTER_TERMS_OF_USE_LINK',
            },
            privacyPolicy: {
                link: 'https://www.e-boks.com/danmark/da/privatlivspolitik/',
                label: 'FOOTER_PRIVACY_POLICY_LINK',
            },
            cookies: {
                link: 'https://www.e-boks.com/danmark/da/cookies/',
                label: 'FOOTER_COOKIES_LINK',
            },
            contact: {
                link: 'https://www.e-boks.com/danmark/da/kontakt/',
                label: 'FOOTER_CONTACT_LINK',
            },
        },
        mySenders: {
            publicServiceBodies: {
                link: 'https://digitalpostbox.ie/who-can-send-me-digital-post/',
                label: 'Public Service Bodies',
            },
        },

        digitalPostRights: {
            administrateRights: {
                links: {
                    // company: 'https://virk.dk/',
                    // citizen: 'https://www.borger.dk/',
                    company: staticConfig.envaccesscompany,
                    citizen: staticConfig.envaccesscitizen,
                },
                label: 'ADMINISTER_ACCESS',
            },
        },
        legallyNotify: {
            readMore: {
                link: 'https://domstol.dk/alle-emner/forkyndelse/',
                label: 'READ_MORE',
            },
        },
        digitalPost: {
            virk: {
                link: 'https://virk.dk',
                label: 'Virk.dk',
            },
            borger: {
                link: 'https://borger.dk',
                label: 'Borger.dk',
            },
        },
    },
    texts: {
        onboardingWelcomePage: {
            title: 'Welcome to e-Boks',
            text: 'Some welcome text from Portal service',
            skipButtonLabel: 'Skip intro',
        },
        application: {
            title: 'e-Boks',
        },
    },
    colors: {
        buttons: {
            primary: {
                background: '#bb1d2c',
                color: '#ffffff',
            },
            secondary: {
                background: '#e3e3e3',
                color: '#000000',
            },
            black: {
                background: '#000000',
                color: '#ffffff',
            },
        },
        links: {
            primary: {
                color: '#bb1d2c',
            },
            secondary: {
                color: '#004769',
            },
            light: {
                color: '#ffffff',
            },
            dark: {
                color: '#000000',
            },
        },
        error: {
            background: '#bb1d2c',
            color: '#ffffff',
        },
        popup: {
            background: '#f5f5f5',
            color: '#7f7f7f',
        },
        mailbox: {
            background: '#ffffff',
            unreadMailCounterColor: '#bb1d2c',
            manageSendersLabel: '#7f7f7f',
        },
        sidebar: {
            background: '#f5f5f5',
            folderNameColor: '#333',
        },
        header: {
            background: '#233e4b',
            logoBackground: '#14242c',
            color: '#fff',
        },
        mailItem: {
            hoverBackground: '#d8eff7',
            titleColor: '#233e4b',
            color: '#6b6b6b',
        },
        mySenders: {
            publicAuthoritiesTextColor: '#000000',
            sendersTextColor: '#000000',
        },
        toggle: {
            backgroundActive: '#67bd53',
            backgroundNotActive: '#e3e3e3',
            toggleTextColor: '#727272',
        },
    },
    logos: {
        footer: {
            organizationLogo: 1,
            poweredByLogo: 1,
        },
        header: {
            logo: 1,
            logoSmall: 2,
            logoMedium: 1,
        },
        application: {
            favicon: 0,
        },
    },
    features: {
        quota: {
            configuration: false,
        },
        data: {
            export: false,
        },
        user: {
            delete: false,
        },
        message: {
            reply: true,
            forward: true,
            archive: false,
            move: true,
            delete: true,
            save: true,
            print: true,
            read: true,
            rename: false,
            note: {
                add: true,
            },
            information: true,
            send: true,
            signing: false,
        },
        folder: {
            customFolders: true,
        },
    },
};
